import MarkdownIt from 'markdown-it';
import { PropTypes } from 'prop-types';
import { urlRegex } from './general';

const mdParser = new MarkdownIt();

const defaultRender =
  // mdParser.renderer.rules.link_open ||
  function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

// Add target _blank to links
mdParser.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  const aIndex = tokens[idx].attrIndex('target');
  const hIndex = tokens[idx].attrIndex('href');

  // Backfill url if it's blank with label (if it's a url)
  if (hIndex !== -1) {
    if (tokens[idx].attrs[hIndex][1] === '') {
      if (tokens[idx + 1] && tokens[idx + 1].type === 'text') {
        if (urlRegex.test(tokens[idx + 1].content)) {
          tokens[idx].attrs[hIndex][1] = tokens[idx + 1].content;
        }
      }
    }
  }

  if (aIndex < 0) {
    tokens[idx].attrPush(['target', '_blank']);
  } else {
    tokens[idx].attrs[aIndex][1] = '_blank';
  }

  return defaultRender(tokens, idx, options, env, self);
};

const RenderMd = ({ md = '', children = '', ...props }) => {
  const body = children || md;
  return (
    <div
      {...props}
      dangerouslySetInnerHTML={{ __html: mdParser.render(body.replace(/\\n/g, '\u000A')) }} // eslint-disable-line
    />
  );
};

RenderMd.propTypes = {
  md: PropTypes.string,
  children: PropTypes.any,
};

export default RenderMd;
